import { useCallback, useState } from 'react'

export const useBool = (initial = false) => {
  const [value, setValue] = useState(initial)

  const onTrue = useCallback(() => setValue(true), [])
  const onFalse = useCallback(() => setValue(false), [])
  const onToggle = useCallback(() => setValue(v => !v), [])
  const onReset = useCallback(() => setValue(initial), [initial])

  return {
    value,
    onTrue,
    onFalse,
    onToggle,
    onReset,
  }
}
